import { render, staticRenderFns } from "./GeneralInfoStep.vue?vue&type=template&id=7641b404&scoped=true"
import script from "./GeneralInfoStep.vue?vue&type=script&lang=js"
export * from "./GeneralInfoStep.vue?vue&type=script&lang=js"
import style0 from "./GeneralInfoStep.vue?vue&type=style&index=0&id=7641b404&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7641b404",
  null
  
)

export default component.exports